import { ConnectedWallet, PrivyInterface, usePrivy, useWallets, UseWalletsInterface } from '@privy-io/react-auth'
import { useEffect, useState } from 'react'

export const usePrivyWrapper = (): {
  lastConnectedWallet: ConnectedWallet | null
  recentConnectedWallet: ConnectedWallet | null
} & PrivyInterface &
  UseWalletsInterface => {
  const privy = usePrivy()
  const { wallets } = useWallets()
  const [lastConnectedWallet, setLastConnectedWallet] = useState<ConnectedWallet | null>(null)
  const [recentConnectedWallet, setRecentConnectedWallet] = useState<ConnectedWallet | null>(null)

  useEffect(() => {
    if (wallets.length > 0) {
      setLastConnectedWallet(wallets[0])
      if (Date.now() - wallets[0].connectedAt < 3000) {
        setRecentConnectedWallet(wallets[0])
      }
    }
  }, [wallets])

  return {
    ...privy,
    wallets,
    lastConnectedWallet,
    recentConnectedWallet,
  }
}
